import { ToolboxBlock, ToolboxCategory } from "../Blockly/types/config";
import { DEFAULT_TOOLBOX_ITEMS } from "../Blockly/assets/toolboxitems";

const makeBlock = (type: string, editable: boolean): ToolboxBlock => ({
  type,
  movable: editable,
  deletable: editable,
  editable,
  updatable: editable,
});
export function buildProjectToolbox(editable: boolean): ToolboxCategory[] {
  const wanted: Record<string, string[] | undefined> = {
    Mouvement: undefined,
    Events: ["on_key_press"],
    Fonctions: [
      "on_timer",
      "delai",
      "procedures_defnoreturn",
      "procedures_defreturn",
      "procedures_callnoreturn",
      "procedures_callreturn",
    ],
    Control: undefined,
    Logic: undefined,
    Math: undefined,
    Input: undefined,
    Variables: undefined,
    Text: undefined,
  };
  const result: ToolboxCategory[] = [
    {
      name: "Scène et personnages",
      color: "20",
      blocks: [
        "project_set_scene",
        "project_add_character",
        "project_add_obstacle",
        "project_set_win",
      ].map((type) => makeBlock(type, editable)),
    },
  ];
  Object.entries(wanted).forEach(([name, types]) => {
    const category = DEFAULT_TOOLBOX_ITEMS.find((item) => item.name === name);
    if (!category) return;
    const blocks = category.blocks
      .filter((block) => !types || types.includes(block.type))
      .map((block) => makeBlock(block.type, editable));
    result.push({ name: category.name, color: category.color, blocks });
  });
  return result;
}
